import { nsElements, statusProps } from '../config';
export const setAttributeToElement = (el, tag, key, value) => {
    if (statusProps.includes(key)) {
        el[key] = value;
    }
    else {
        if (nsElements.includes(tag)) {
            el.setAttributeNS(null, key, String(value));
        }
        else {
            el.setAttribute(key, String(value));
        }
    }
};
